import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dropdown, Switch, Button, Drawer, ConfigProvider, theme, Tooltip } from 'antd';
import moment from 'moment';
import './topnav.css';
import { TeamOutlined, BulbOutlined, BulbFilled, UserSwitchOutlined, FieldTimeOutlined, QuestionOutlined } from '@ant-design/icons';
import TimeRangeModal from './modal/TimeRangeModal';
import ParentMenu from '../help/ParentMenu';

import {
	userSideNav,
	userUpdateOrganization,
	userUpdateTheme
} from '../../modules/user';


import {
	trendCDNGetList
} from '../../modules/analytics';

import {
	inspectionTimeUpdate
} from '../../modules/analytics';

import {
	organizationList
} from '../../modules/organization';
import { accountId } from '../../config';



class TopNav extends Component {

	constructor(props) {
		super(props);
		this.state = {
			fullscreen: false,
			addTimeRangeModal: false,
			env: localStorage.env ? localStorage.env : 'live',
			open: false
		};
	}

	componentDidMount() {
		this.props.organizationList();
	}
	componentDidUpdate(prevProps) {
		const { organizations, selectedOrganization } = this.props;
		if (JSON.stringify(selectedOrganization) !== JSON.stringify(prevProps.selectedOrganization)) {
			let organization = organizations.find(org => (org.code === selectedOrganization));
			localStorage.setItem('apiKey', localStorage.env === 'live' ? organization.apiKey : organization.apiKeySandbox);
		}
	}

	onSelectOrganization(value) {
		const { inspectionTime } = this.props;
		this.props.userUpdateOrganization(value);
		this.props.inspectionTimeUpdate(inspectionTime);
	}


	onUpdateTheme(checked) {
		this.props.userUpdateTheme((checked) ? 'light' : 'dark');
	};
	onUpdateEnv(key, env) {
		localStorage.setItem('apiKey', key);
		localStorage.setItem('env', env);
		this.setState({ env: env });
		const { inspectionTime } = this.props;
		this.props.inspectionTimeUpdate(inspectionTime);
		window.location.reload();
	};


	goTeam() {
		this.props.history.push('/organization')
	}


	toggleTimeRangeModal = () => {
		const { addTimeRangeModal } = this.state;
		this.setState({ addTimeRangeModal: !addTimeRangeModal });
	}
	showDrawer = () => {
		this.setState({ open: true });
	};
	onClose = () => {
		this.setState({ open: false });
	};


	render() {
		const { defaultAlgorithm, darkAlgorithm } = theme;
		const { simple, userProfile, organizations, selectedOrganization, userTheme, appTitle, inspectionTime } = this.props;
		let userRole = userProfile?.user?.role;
		let { addTimeRangeModal } = this.state;
		let organization = organizations.find(org => (org.code === selectedOrganization));
		if (localStorage.apiKey === undefined) {
			if (organization !== undefined) {
				localStorage.setItem('apiKey', localStorage.env === 'live' ? organization.apiKey : organization.apiKeySandbox);
			}
		}
		let org_name = (organizations.find(org => org.code === selectedOrganization)) ? organizations.find(org => org.code === selectedOrganization).name : selectedOrganization;
		const menuItems = (organizations) ? organizations.map(org => ({
			key: org.code,
			label: <div key={org.code} onClick={() => { this.onSelectOrganization(org.code) }}>{org.name}</div>
		})
		) : [];


		if (simple || !userProfile || !userProfile.user) {
			return (
				<div className="topNavWrapper">
					<div className="topNavTitle">
					</div>
				</div>
			);
		} else {
			return (
				<ConfigProvider theme={{
					algorithm: userTheme === 'dark' ? darkAlgorithm : defaultAlgorithm,
				}}>
					<div className="topNavWrapper">
						{/* {
					['/marketplace'].includes(this.props.router.location.pathname) &&
					<h1>
						<div className="logoHolder fullIcon"></div>
					</h1>
				} */}
						<div className="topNavTitle">{appTitle && appTitle.title} {appTitle && appTitle.showOrg && <b>{` - ${selectedOrganization.toUpperCase()}`}</b>}</div>
						<h4 className="headerContentHolder">
							{/* 				
				<Switch
					checkedChildren='Production'
					unCheckedChildren={<span style={{color: userTheme === 'light'?'black':'white'}} >Sandbox</span>}
					checked={this.state.env === 'live'}
					onChange={(va)=>{
						this.onUpdateEnv(va?organization.apiKey:organization.apiKeySandbox?organization.apiKeySandbox:organization.apiKey, va?'live':'sandbox')}
					}
						
				/>
				{appTitle && appTitle.showTime &&
				<Button shape="round" size={`small`} icon={<FieldTimeOutlined />}  className="seleterHolder" onClick={this.toggleTimeRangeModal.bind(this)}>
					{moment(inspectionTime.till).subtract(inspectionTime.day, 'days').format('YYYY-MM-DD HH:00')} - {moment(inspectionTime.till).format('YYYY-MM-DD HH:00')}
				</Button> */}
							{/* <Switch
					checkedChildren={<BulbFilled />}
					unCheckedChildren={<BulbOutlined />}
					checked={userTheme==='light'}
					onChange={(va)=>{
						
						this.onUpdateTheme(va)}
					}
				/> */}
							{
								(userRole.includes('admin')) &&
								<Button shape="round" size={`small`} icon={<TeamOutlined />} className="seleterHolder" onClick={() => this.goTeam()}>
									{accountId}
								</Button>
							}

							{/* {userProfile && userProfile.user && userProfile.user.access && userProfile.user.access.includes("crossOrganization") &&
						<Dropdown menu={{items:menuItems}} placement="bottomRight" trigger={['click']}>
							<Button shape="round" size={`small`} icon={<UserSwitchOutlined />}  className="seleterHolder">
							</Button>
						</Dropdown>
        } */}
							{
								accountId !== 'vivamax' && accountId !== 'astro' &&
								<Tooltip title="Help">
									<Button shape="circle" size={`small`} icon={<QuestionOutlined />} className="questionIcon" onClick={this.showDrawer} />
								</Tooltip>
							}

							<Drawer title="Help" width={350} closable={false} onClose={this.onClose} open={this.state.open}>
								<ParentMenu />
							</Drawer>
						</h4>

						<TimeRangeModal
							show={addTimeRangeModal}
							toggleTimeRangeModal={this.toggleTimeRangeModal.bind(this)}
						/>

					</div>

				</ConfigProvider>
			);
		}
	}

}

const mapStateToProps = state => ({
	router: state.router,
	userAuthenticated: state.user.userAuthenticated,
	userNav: state.user.userNav,
	userProfile: state.user.userProfile,
	selectedOrganization: state.user.selectedOrganization,
	userTheme: state.user.userTheme,
	appTitle: state.user.appTitle,
	organizations: state.organization.organizations,
	inspectionTime: state.analytics.inspectionTime
});



const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			userSideNav,
			userUpdateOrganization,
			userUpdateTheme,
			organizationList,
			inspectionTimeUpdate,
			trendCDNGetList
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopNav));
